<template>
	<section class="container__body container__body--md">

		<section class="col-12 margin-b-50">

			<a href="#" class="btn btn--sm btn--secondary secondary--grey" @click.prevent="showCreateModal = true">Opret gruppe</a>

		</section>

		<draggable v-model="selections">

			<transition-group name="fade">

				<section class="data-list margin-b-100" v-for="selection in selections" :key="selection.id">

					<header class="col-12 margin-b-50 settings">

						<h1 v-text="selection.title"></h1>

						<ws-dropdown>

							<template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>

							<template slot="content">

								<ul>
									<li><a href="#" @click.prevent="showEditSelectionModal(selection)"><i class="fas fa-pencil-alt"></i> Rediger</a></li>
									<li><a href="#" @click.prevent="showDeleteSelectionModal(selection)"><i class="fas fa-trash-alt"></i> Slet</a></li>
								</ul>

							</template>

						</ws-dropdown>

					</header>

					<section class="item" v-for="option in selection.options">

						<section class="icon">

							<i class="icon--lg fas fa-shopping-bag"></i>

						</section>

						<section class="content">

							<h1 v-text="option.title"></h1>

							<ul>
								<li>Der kan vælges {{selection.min_options}} stk {{selection.title}}</li>
							</ul>

							<section class="premium">

	                            <label><input type="checkbox"  v-model="option.premium" @click.stop="makeOptionPremium(option, selection)"> Premium</label>

							</section>


						</section>

						<section class="link">

							<a href="product-stats" @click.prevent="removeOption(selection, option)">Fjern</a>

						</section>

					</section>

					<section class="item--add padding-tb-50" @click.prevent="openAddOptionModal(selection)">

						<section class="icon">

							<i class="fas fa-plus-circle"></i>

						</section>

						<section class="content">

							<h2>Tilføj tilvalg</h2>

						</section>

					</section>

				</section>

				<section class="data-list" v-if="selections.length == 0" key="notfound">

					<h4>Ingen grupper fundet</h4>

				</section>

			</transition-group>

		</draggable>

		<section class="col-12 margin-t-75">

			<button class="btn btn--md btn--primary primary--copper" @click.prevent="updateOptions" :disabled="isSaving || !validateSelectionsAndOptions">

				<span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

				<span v-else>Gem og fortsæt</span>

			</button>

		</section>

		<ws-modal v-model="showOptionListModal">

			<section class="modal-wrap--search">

				<section class="modal--sm">

					<span class="close" @click.prevent="showOptionListModal = false"><i class="fas fa-times"></i></span>

					<options-list @selected="addOption" :selection-options="currentSelectionOptionsById" v-if="currentSelection"></options-list>

				</section>

			</section>

		</ws-modal>

        <ws-modal v-model="showCreateModal">

            <section class="modal-wrap">

                <section class="modal--sm">

                    <h1 class="margin-b-100">Opret gruppe</h1>

                    <span class="close" @click.prevent="showCreateModal = false"><i class="fas fa-times"></i></span>

                    <selection-form @completed="selectionCreated"></selection-form>

                </section>

            </section>

        </ws-modal>

		<ws-modal v-model="showEditModal">

			<section class="modal-wrap">

				<section class="modal--sm">

					<h1 class="margin-b-100">Rediger gruppe</h1>

					<span class="close" @click.prevent="showEditModal = false"><i class="fas fa-times"></i></span>

					<selection-form @completed="selectionUpdated" :selection="currentSelection"></selection-form>

				</section>

			</section>

		</ws-modal>

		<ws-modal v-model="showDeleteModal">

			<section class="modal-wrap">

				<section class="modal--sm center" v-if="currentSelection">

					<span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-trash-alt icon--lg margin-b-25"></i>

					<h1>Slet gruppe?</h1>

					<h2>Er du sikker på du vil slette {{currentSelection.title}}?</h2>

					<h3>Du kan ikke fortryde denne handling!</h3>

					<section class="col-12 margin-t-25">

						<a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteSelection">Ja tak</a>

						<a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

					</section>

				</section>

			</section>

		</ws-modal>

	</section>
</template>

<script>
	import {mapGetters} from 'vuex';
	import SelectionForm from './components/selectionForm.vue';
	import OptionsList from './components/optionsList.vue';
    export default {
        name: "options",
		data(){
            return {
                selections:[],
				showOptionListModal:false,
				showCreateModal:false,
				showEditModal:false,
				showDeleteModal:false,
				currentSelection:null,
				isSaving:false,
			}
		},
		components:{
            SelectionForm,
			OptionsList
		},
		computed:{
			...mapGetters({
				product:'product'
			}),
			validateSelectionsAndOptions(){
				let isValid = true;

				this.selections.forEach(item => {
				    if(item.options.length < item.min_options){
				        isValid = false;
					}
				});
				return isValid;
			},
			currentSelectionOptionsById(){
			    if(!this.currentSelection){
			        return null;
				}
			    return this.currentSelection.options.map(item=>{
			        return item.id;
				});
			}
		},
		watch:{
          	product(value){
          	    if(value !== null){
          	        this.getSelections();
				}
			}
		},
		methods:{
            getSelections(){
                this.$emit('refreshSelections');
				axios.get(`/api/admin/product/${this.product.id}/selection`).then(response => {
				    this.selections = response.data.data;
				    this.originalSelections = response.data.data;
				});
			},
            updateSelectionArray(data){

                if(data.hasOwnProperty('isUpdating')){
                    const selection = this.selections.find((item)=>{
                        return item.id == data.id;
					});

					selection.title = data.title;
					selection.min_options = data.min_options;

					selection.options.forEach(option => {
					    option.premium = false;
                    })

					return;
				}

                if(data.hasOwnProperty('isDeleting')){
                    this.selections = this.selections.filter((item)=>{
                        return item.id !== data.id;
					});

                    return;
                }
				this.selections.push(data);

			},
			openAddOptionModal(selection){
				this.showOptionListModal = true;
				this.currentSelection = selection;
			},
			addOption(option){
              	this.currentSelection.options.push(option);
              	this.showOptionListModal = false;
              	this.currentSelection = null;
			},
			removeOption(selection, option){
				selection.options = selection.options.filter(item =>{
				    return item !== option;
				})
			},
			updateOptions(){
                if(this.isSaving){
                    return;
				}

				if(!this.validateSelectionsAndOptions){
				    return;
				}

				this.isSaving = true;

				axios.put(`/api/admin/product/${this.product.id}/selection/batch`, {
				    selections: this.selections.map(item => {
				        return {
				            selection_id: item.id,
							options: item.options.map(option => {
							    if(option.premium){
							        return {
							            id: option.id,
                                        premium: true,
                                    }
                                }

							    return option.id;
							}),
						};
					}),
					orders: this.selections.map((item, index) => {
					   return {
					       selection_id: item.id,
						   order: index + 1,
					   }
					}),
				}).then(response => {
				    this.isSaving = false;
                    this.$router.replace({
                        name:'product.edit.extra',
                    });
				});
			},
			showEditSelectionModal(selection){
                this.currentSelection = selection;
				this.showEditModal = true;
			},
			showDeleteSelectionModal(selection){
                this.currentSelection = selection;
                this.showDeleteModal = true;
			},
            selectionCreated(data){
                this.showCreateModal = false;
                this.updateSelectionArray(data);

            },
			selectionUpdated(data){
                this.showEditModal = false;
                this.updateSelectionArray(data);
                this.currentSelection = null;
			},
			deleteSelection(selection){
                axios.delete(`/api/admin/product/${this.product.id}/selection/${this.currentSelection.id}`).then(response=>{
                    this.showDeleteModal = false;
                    selection = this.currentSelection;
                    selection.isDeleting = true;
                    this.updateSelectionArray(selection);
                    this.currentSelection = null;
				});
			},
            makeOptionPremium(option, selection){
                console.log("make premium");

                if(option.premium){
                    return option.premium = false;
                }

                const currentNumberOfPremiumOptions = selection.options.map(function(option){
                   return option.premium ? 1:0;
                }).reduce((total, currentValue, currentIndex, options) => {
                    return total + currentValue;
                });

                console.log(currentNumberOfPremiumOptions);

                if(selection.options.length > selection.min_options && (currentNumberOfPremiumOptions + 1) <= (selection.options.length - selection.min_options)){
                    option.premium = true;
                }

            }
		},
        beforeRouteEnter(to, from, next){
            next(vm=>{
                vm.$store.dispatch('getProduct', vm.$route.params.product);
            })
        },
    }
</script>

<style scoped>

</style>
